import { createGlobalStyle } from "styled-components";

// Body/typography lives in src/index.css; this stays only to satisfy the
// existing ThemeProvider wiring in App.js. Keep empty unless a styled
// component genuinely needs a global escape hatch.
export const GlobalStyles = createGlobalStyle``;
